export function setRootCssProperty(key: string, value: string): void {
  if(typeof window === 'undefined') {
    return;
  }

  window.document
    .documentElement
    .style
    .setProperty(`--${ key }`, value);
}